import { type CharterSortBy } from '@ankor-io/common/types/charter'

export type CharterSortOrder = 'asc' | 'desc'

export type CharterTableSort = {
  sortBy: CharterSortBy
  sortOrder: CharterSortOrder
}

export const DEFAULT_CHARTER_TABLE_SORT: CharterTableSort = {
  sortBy: 'startDate',
  sortOrder: 'desc',
}

const DEFAULT_SORT_ORDER: Partial<Record<CharterSortBy, CharterSortOrder>> = {
  startDate: 'desc',
  endDate: 'desc',
  name: 'asc',
  status: 'asc',
  currencyCode: 'asc',
  apaCents: 'asc',
}

export function getDefaultSortOrder(sortKey: CharterSortBy): CharterSortOrder {
  return DEFAULT_SORT_ORDER[sortKey] ?? 'desc'
}

export function getNextCharterSort(current: CharterTableSort, clicked: CharterSortBy): CharterTableSort {
  if (current.sortBy === clicked) {
    return {
      sortBy: clicked,
      sortOrder: current.sortOrder === 'desc' ? 'asc' : 'desc',
    }
  }

  return {
    sortBy: clicked,
    sortOrder: getDefaultSortOrder(clicked),
  }
}
